import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ApexChart } from 'ng-apexcharts';
import { ChartOptions } from 'services/models/charts/ChartOptions';
import { FormMetricsBinaryThermometerChartData } from 'services/models/form-builder/form-metrics/chart-data/binary-thermometer-chart-data.model';
import { FormMetricsCategoryClickEvent } from 'services/models/form-builder/form-metrics/form-metrics-drilldown.model';
import { FormMetricsRespondentAnswerItemModel } from 'services/models/form-builder/form-metrics/form-metrics-drilldown.model';
import { FormMetricsItemModel } from 'services/models/form-builder/form-metrics/form-metrics-item.model';
import { FormMetricsChartMapperService } from '../../services/form-metrics-chart-mapper.service';
import { FormMetricsLegendItem } from '../../utils/form-metrics-legend.util';
import {
  applyHighlightColors,
  buildCategoryClickEvent,
  findHighlightForItem,
  FormMetricsSliceMeta,
  resolveHighlightedIndexes,
} from '../../utils/form-metrics-drilldown.util';

@Component({
  selector: 'app-form-metrics-binary-thermometer-widget',
  templateUrl: './form-metrics-binary-thermometer-widget.component.html',
  styleUrls: ['./form-metrics-binary-thermometer-widget.component.scss'],
})
export class FormMetricsBinaryThermometerWidgetComponent implements OnChanges {
  @Input() item!: FormMetricsItemModel;
  @Input() categoryClickEnabled = false;
  @Input() highlightAnswers: FormMetricsRespondentAnswerItemModel[] = [];
  @Output() categoryClick = new EventEmitter<FormMetricsCategoryClickEvent>();

  chartOptions: Partial<ChartOptions> | null = null;
  legendItems: FormMetricsLegendItem[] = [];

  constructor(private chartMapper: FormMetricsChartMapperService) {}

  ngOnChanges(_changes: SimpleChanges): void {
    this.rebuild();
  }

  private rebuild(): void {
    if (!this.item || this.item.totalAnswers <= 0) {
      this.chartOptions = null;
      this.legendItems = [];
      return;
    }

    const mapped = this.chartMapper.mapBinaryThermometer(this.item);
    const data = this.item.chartData as FormMetricsBinaryThermometerChartData;
    const slices: FormMetricsSliceMeta[] = [
      {
        optionId: null,
        label: data?.positiveLabel || 'Positivo',
        value: data?.positiveLabel || 'Positivo',
      },
      {
        optionId: null,
        label: data?.negativeLabel || 'Negativo',
        value: data?.negativeLabel || 'Negativo',
      },
    ];
    const highlight = findHighlightForItem(this.highlightAnswers, this.item.formItemId);
    const highlightedIndexes = resolveHighlightedIndexes(slices, highlight);
    const baseColors = (mapped.chartOptions.colors as string[]) || [];

    const chart: ApexChart = {
      ...(mapped.chartOptions.chart as ApexChart),
    };
    if (this.categoryClickEnabled) {
      chart.events = {
        dataPointSelection: (_event, _ctx, config) => {
          const index = config?.seriesIndex;
          const slice = slices[index];
          if (!slice) {
            return;
          }
          this.categoryClick.emit(
            buildCategoryClickEvent(this.item.formItemId, this.item.chartType, slice)
          );
        },
      };
    }

    this.chartOptions = {
      ...mapped.chartOptions,
      colors: applyHighlightColors(baseColors, highlightedIndexes),
      chart,
    };
    this.legendItems = mapped.legendItems;
  }
}
